import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { MinusCircleIcon } from '@phosphor-icons/react/MinusCircle';

export const StyledContainerGrid = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const StyledExcludeItemsRemoveIconButton = styled(IconButton)`
  padding: 0;
`;

export const StyledExcludeItemsRemoveIcon = styled(MinusCircleIcon)`
  color: ${({ theme }) => theme.palette.error.main};
  margin-top: none;
  margin-right: ${({ theme }) => theme.spacing(1.5)};
`;

export const StyledChildrenGrid = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(0.2)};
`;
